import { color } from 'asserts/styles/colors';
import styled from 'styled-components';
import * as S from 'components/join/Step1';

import { ReactComponent as IconRemove } from 'asserts/icons/ic_remove_circle_lined.svg';
import { ReactComponent as IconAdd } from 'asserts/icons/ic_add_circle_lined.svg';
import { ReactComponent as IconDelete } from 'asserts/icons/ic_delete.svg';
import { font } from 'asserts/styles/fonts';
import { Action } from 'layout/SubscribeHistoryLayout';
import { getSubscriptionType } from 'utils/common';

interface MemberShipPriceCardProps {
  price: number;
  name: string;
  divisiondata: DivisionItem[];
  subscribetype: 1 | 2 | 3 | 4 | 5 | 6 | 7 ;
  count: number;
  licenseData?: boolean;
  handleClickRemoveFromCart: (membershipName: string) => void;
  handleClickChangeCount: (action: Action) => void;
}

const MemberShipPriceCard = ({
  name,
  price,
  subscribetype,
  count,
  divisiondata,
  licenseData,
  handleClickRemoveFromCart,
  handleClickChangeCount
}: MemberShipPriceCardProps) => {
  const divisionNames = divisiondata
    .map((item) => {
      return item.recommendyn || !item.hasOwnProperty('recommendyn') ? item.divisionname : null;
    })
    .filter(Boolean);

  const isFreeCheck = subscribetype === 5;

  return (
    <Wrapper>
      <DeleteButtonWrapper onClick={() => handleClickRemoveFromCart(name)}>
        <IconDelete />
      </DeleteButtonWrapper>
      <InnerWrapper>
        <div>
          <h4>{name}</h4>
          <p>기본이용권 {divisiondata.length !== 0 && '+ 검사이용권'}</p>
        </div>
        <section>
          <CountWrapper $licenseData={licenseData} $isFreeCheck={isFreeCheck}>
            <IconRemove fill="#92CAFF" onClick={() => handleClickChangeCount('decrement')} />
            <div>{count}</div>
            <IconAdd fill="#92CAFF" onClick={() => handleClickChangeCount('increment')} />
          </CountWrapper>
          <SelectMenuWrapper>
            <p>{getSubscriptionType(subscribetype)}</p>
            <Price>{(price * count).toLocaleString()}원</Price>
          </SelectMenuWrapper>
        </section>
        {divisiondata.length !== 0 && divisionNames.length !== 0 && (
          <>
            <S.Line className="line" /> <SelectedItem>{divisionNames.join(', ')}</SelectedItem>
          </>
        )}

        <S.Line className="line" />
        <TotalPriceWrapper>
          <div>합계</div>
          <PriceWrapper>
            <Price>{(price * count).toLocaleString()}원</Price>
          </PriceWrapper>
        </TotalPriceWrapper>
      </InnerWrapper>
    </Wrapper>
  );
};

export default MemberShipPriceCard;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 20px;
  color: ${color.opacityBlack06};
  font-size: 14px;
  line-height: 18px;
  border-radius: 12px;
  border: 1px solid ${color.opacityBlack01};
  background: ${color.white};

  h4 {
    color: ${color.black2};
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    padding-bottom: 8px;
  }

  & p {
    color: ${color.gray700};
    font-size: 14px;
    line-height: 18px;
  }

  p.line {
    margin: 0;
    background-color: #eee;
  }

  section {
    display: flex;
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const DeleteButtonWrapper = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

const Price = styled.div`
  color: ${color.black2};
  text-align: right;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
`;

const CountWrapper = styled.div<{ $licenseData?: boolean; $isFreeCheck: boolean }>`
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  width: 100%;
  pointer-events: ${(props) => (props.$licenseData || props.$isFreeCheck ? 'none' : 'initial')};
  opacity: ${(props) => (props.$licenseData || props.$isFreeCheck ? 0.3 : 1)};

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    ${font.h4_medium};
    color: ${color.black2};
  }

  svg {
    width: 24px;
    height: 24px;
    cursor: pointer;
    pointer-events: ${(props) => (props.$licenseData || props.$isFreeCheck ? 'none' : 'initial')};
    opacity: ${(props) => (props.$licenseData || props.$isFreeCheck ? 0.9 : 1)};
  }
`;

const SelectMenuWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;

  p {
    color: ${color.gray700};
    ${font.caption1_regular};
    line-height: 1.8;
  }
`;

const Layout = styled.div`
  display: flex;
  align-items: center;
`;

const PriceWrapper = styled(Layout)`
  gap: 6px;

  div {
    color: ${color.blue300};
  }
`;

const TotalPriceWrapper = styled(Layout)`
  justify-content: space-between;
  width: 100%;

  color: ${color.opacityBlack08};
  ${font.body_medium};
`;

const SelectedItem = styled.div``;
